export const SEARCH_INITIAL = 'SEARCH_INITIAL';
export const SEARCH_INITIAL_SUCCESS = `${SEARCH_INITIAL}_SUCCESS`;
export const SEARCH_INITIAL_FAIL = `${SEARCH_INITIAL}_FAIL`;

const initialState = {
  isLoading: false,
  isLoaded: false,
  filter: null,
  error: null,
  data: null,
};

const searchReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SEARCH_INITIAL:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        filter: action.payload.filter,
        data: null,
      };
    case SEARCH_INITIAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: action.payload.data.data,
      };
    case SEARCH_INITIAL_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
};

export default searchReducer;
